<template>
  <!-- eslint-disable vue/no-v-html -->
  <div
    v-if="html"
    class="c-wysiwyg"
    v-html="html"
  />
  <div
    v-else
    class="c-wysiwyg"
  >
    <slot />
  </div>
  <!-- eslint-disable vue/no-v-html -->
</template>

<script>
export default {
  name: "Wysiwyg",
  props: {
    html: {
      type: String,
      default: null
    },
    paragraphSize: {
      type: String,
      default: 'regular',
    },
    linkColor: {
      type: String,
      default: 'regular'
    }
  },
  mounted() {
    this.applyTypographies();
  },
  methods: {
    applyTypographies() {
      let paragraphTags = this.$el.getElementsByTagName('p');
      let aTags = this.$el.getElementsByTagName('a');
      let h5Tags = this.$el.getElementsByTagName('h5');
      let h4Tags = this.$el.getElementsByTagName('h4');
      let h3Tags = this.$el.getElementsByTagName('h3');
      let olTags = this.$el.getElementsByTagName('ol');
      let ulTags = this.$el.getElementsByTagName('ul');
      if (paragraphTags) {
        for (let j = 0; j < paragraphTags.length; j++) {
          if(this.paragraphSize == 'regular') {
            paragraphTags[j].setAttribute('class', 't-paragraph');
          } else if (this.paragraphSize == 'large') {
            paragraphTags[j].setAttribute('class', 't-paragraph-large');
          } else if (this.paragraphSize == 'small') {
            paragraphTags[j].setAttribute('class', 't-paragraph-small');
          } else if (this.paragraphSize == 'none') {
            paragraphTags[j].style.display = "none";
          }

        }
      }
      if (aTags) {
        for (let j = 0; j < aTags.length; j++) {
          switch (this.linkColor) {
          case 'regular':
            aTags[j].setAttribute('class', 't-link');
            break;
          case 'white':
            aTags[j].setAttribute('class', 't-link t-link--white');
            break;
          default:
            aTags[j].setAttribute('class', 't-link');
          }
        }
      }
      if (h4Tags) {
        for (let j = 0; j < h4Tags.length; j++) {
          if(this.paragraphSize == 'regular') {
            h4Tags[j].setAttribute('class', 't-paragraph u-font-weight-demi');
          } else if (this.paragraphSize == 'large') {
            h4Tags[j].setAttribute('class', 't-paragraph-large u-font-weight-demi');
          } else if (this.paragraphSize == 'small') {
            h4Tags[j].setAttribute('class', 't-paragraph-small u-font-weight-demi');
          }
        }
      }
      if (h3Tags) {
        for (let j = 0; j < h3Tags.length; j++) {
          if(this.paragraphSize == 'regular') {
            h3Tags[j].setAttribute('class', 't-paragraph u-font-weight-demi');
          } else if (this.paragraphSize == 'large') {
            h3Tags[j].setAttribute('class', 't-paragraph-large u-font-weight-demi');
          } else if (this.paragraphSize == 'small') {
            h3Tags[j].setAttribute('class', 't-paragraph-small u-font-weight-demi');
          }
        }
      }

      if (h5Tags) {
        for (let j = 0; j < h5Tags.length; j++) {
          if(this.paragraphSize == 'regular') {
            h5Tags[j].setAttribute('class', 't-paragraph-small u-font-weight-demi');
          } else if (this.paragraphSize == 'large') {
            h5Tags[j].setAttribute('class', 't-paragraph u-font-weight-demi');
          } else if (this.paragraphSize == 'small') {
            h5Tags[j].setAttribute('class', 't-heading-11');
          }
        }
      }

      if (olTags) {
        for (let j = 0; j < olTags.length; j++) {
          olTags[j].setAttribute('class', 't-list');
        }
      }
      if (ulTags) {
        for (let j = 0; j < ulTags.length; j++) {
          ulTags[j].setAttribute('class', 't-list');
        }
      }
    }
  }
}
</script>

<!-- jgunther - This isn't scoped as using v-html doesn't scope each element. If you add styles to this rememver that it will be global and you should add them inside the .c-wysiwyg to contain them-->
<style lang="scss">
  .c-wysiwyg {
    font-size: rem(14px);
    line-height: rem(27px);
    letter-spacing: rem(0.44px);
    font-weight: $font-weight-book;

    h3 + p {
      margin-top: rem(20px);
    }
    h3 + ol {
      margin-top: rem(20px);
    }
    h3 + ul {
      margin-top: rem(20px);
    }
    h3 + h4 {
      margin-top: rem(20px);
    }
    h3 + h5 {
      margin-top: rem(20px);
    }

    h4 + p {
      margin-top: rem(20px);
    }
    h4 + ol {
      margin-top: rem(20px);
    }
    h4 + ul {
      margin-top: rem(20px);
    }
    h4 + h3 {
      margin-top: rem(30px);
    }
    h4 + h5 {
      margin-top: rem(30px);
    }

    p + h3 {
      margin-top: rem(30px);
    }
    p + h4 {
      margin-top: rem(30px);
    }
    p + h5 {
      margin-top: rem(30px);
    }
    p + ol {
      margin-top: rem(20px);
    }
    p + ul {
      margin-top: rem(20px);
    }

    ol + p {
      margin-top: rem(20px);
    }
    ol + h3 {
      margin-top: rem(30px);
    }
    ol + h4 {
      margin-top: rem(30px);
    }
    ol + h5 {
      margin-top: rem(30px);
    }

    ul + p {
      margin-top: rem(20px);
    }
    ul + h3 {
      margin-top: rem(30px);
    }
    ul + h4 {
      margin-top: rem(30px);
    }
    ul + h5 {
      margin-top: rem(30px);
    }

    ul {
      margin-left: 20px;
      padding-left: 0;
    }
  }
</style>
